/**
 * @class FilterActiveMobile
 * @classdesc This class handles the active filter buttons that are used for mobile filtering.
 *
 * @extends Core.Component
 */
export default class FiltersActiveMobile extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.activeFilterList = el.querySelector('[data-mobile-active-filter-list]');
  }

  /**
   * This will update the buttons based on the filters being updated asynchronously.
   *
   * @param {HTMLElement} newDom The new elements to update.
   */
  updateFilters(newDom) {
    this.el.classList = newDom.querySelector('[data-filters-active-mobile]').classList;
    this.activeFilterList.innerHTML = newDom.querySelector('[data-mobile-active-filter-list]').innerHTML;
  }
}
